import { formatEdge } from "../edge/formatEdge.js";
import {} from "./Net.js";
import { allEdges } from "./allEdges.js";
export function formatNet(net) {
    return allEdges(net)
        .map((edge) => formatEdge(net, edge))
        .join("\n");
}
//# sourceMappingURL=formatNet.js.map